export enum ENV {
    QC = 'QC',
    UAT = 'UAT',
    DEV = 'DEV',
    PREPROD = 'PREPROD',
    PROD = 'PROD'
}
